import { useState } from "react";
import { toast } from "sonner";
import { Truck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/app/DataTable";
import { useMe } from "@/components/app/MeContext";
import { MovementFromPlansDialog } from "@/components/planning/MovementFromPlansDialog";
import { PLAN_COLS } from "@/components/planning/planCols";

export const movable = (p) => !["draft", "closed", "cancelled"].includes(p.status) && !p.change_hold && p.movement_status !== "fully_assigned";

// why a plan can't go onto a movement yet ("" = it can)
export const moveBlock = (p) => (p.change_hold ? "Change waiting for approval" : ["draft", "closed", "cancelled"].includes(p.status) ? `Plan is ${p.status}`
  : p.movement_status === "fully_assigned" ? "Already fully on a movement" : p.qc_status !== "approved" ? "Waiting for QC approval" : "");

// Planned dispatches with checkboxes -> "Create Movement from Selected" (QC-approved only)
export function PlansTable({ rows, reload, onOpen, rowClickable, testid = "plans-table", exportName = "Planned_Dispatches" }) {
  const { can } = useMe();
  const [sel, setSel] = useState(new Set());
  const [open, setOpen] = useState(false);
  const picked = (rows || []).filter((r) => sel.has(r.id));
  const start = () => {
    if (!picked.length) return toast.error("Tick the planned dispatches to move");
    const bad = picked.filter((p) => !movable(p));
    if (bad.length) return toast.error(`${bad.map((p) => p.planned_dispatch_number).join(", ")} cannot be moved (draft, closed, cancelled, change awaiting approval or fully assigned)`);
    const noQc = picked.filter((p) => p.qc_status !== "approved");
    if (noQc.length) return toast.error(`Movement blocked - QC has not approved ${noQc.map((p) => `${p.planned_dispatch_number} (${p.qc_status.replace(/_/g, " ")})`).join(", ")}`);
    setOpen(true);
  };
  const toolbar = can("logistics.create") && (
    <Button size="sm" onClick={start} disabled={!picked.length} data-testid={`${testid}-create-movement-btn`}><Truck className="h-4 w-4 mr-1" />Create Movement from Selected ({picked.length})</Button>
  );
  return (
    <>
      <DataTable testid={testid} columns={PLAN_COLS} rows={rows} onRowClick={onOpen} rowClickable={rowClickable} selected={can("logistics.create") ? sel : undefined} onSelect={setSel}
        toolbar={toolbar} exportName={exportName} exportPerm="planning.export" empty="No planned dispatches" />
      {open && <MovementFromPlansDialog plans={picked} onClose={() => setOpen(false)} onDone={() => { setOpen(false); setSel(new Set()); reload(); }} />}
    </>
  );
}
